module.exports = __webpack_public_path__ + "files/b4971a219aff474d21006d43b1e36a94.png";